/**
 * The visitor's country, as a hint for pricing ("" when unknown).
 *
 * Only a hint: the backend bills by the country it can work out itself, or by
 * the region stored on the subscription, and uses this only when it has
 * neither. Every price request sends the same hint, so the plan cards, the
 * top-up card and checkout always agree on the currency.
 *
 * Looked up once per page load and shared by every caller.
 */
let lookup = null;

const resolveCountry = async () => {
  try {
    const res = await fetch("https://ipapi.co/json/");
    const data = await res.json();
    if (data?.country_code) return data.country_code;
  } catch {
    // Ad blockers and the free tier's rate limit both land here.
  }
  // Needs no network and is never blocked.
  try {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone || "";
    if (tz === "Asia/Kolkata" || tz === "Asia/Calcutta") return "IN";
  } catch {
    // Nothing left to try; the backend defaults to US.
  }
  return "";
};

export default function getCountryHint() {
  if (!lookup) lookup = resolveCountry();
  return lookup;
}
